import ReactAriaRouterProvider from '../init/ReactAriaRouterProvider';

/**
 * This temporary wrapper component makes sure that all Links in it's children will use SPA navigation and not full page reload.
 * If a Link component from @coop/components (that is based on React Aria) is used without being wrapped in ReactAriaRouterProvider, it will do a full page reload instead of SPA navigation.
 * In normal circumstances, the ReactAriaRouterProvider should be placed once in root of the app, but that means all links will try to soft navigate, i.e. "stores and offers" -> "handla", which will not work since we dont have a shared router instance with all routes yet.
 * Once "Main Router" is in place, this component should be removed and ReactAriaRouterProvider should be used in root of the app.
 */
const ForceSoftNavigation = ({ children }: { children: React.ReactNode }) => {
    return <ReactAriaRouterProvider>{children}</ReactAriaRouterProvider>;
};

export default ForceSoftNavigation;
